import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.historicalRangeData`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const REMOVE_RANGE_DATA = `${SCOPE}/REMOVE_RANGE_DATA`;
